import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";

export interface IRetryItem {
    retry: () => void;
    reason: string;
    cancel: () => void;
}

@NgService({
    token: Token.SecurityRetryService,
    dependencies: [
        Token.$Q,
    ]
})
export class SecurityRetryService {
    constructor(
        private $q: ng.IQService
    ) {

    }
    private retryQueue: IRetryItem[] = [];
    public onItemAdded: () => void;

    public retryAll() {
        while (this.retryQueue.length) {
            this.retryQueue.shift().retry();
        }
    }

    public pushRetryFn(reason, retryFn) {
        let deferredRetry = this.$q.defer();
        let retryItem: IRetryItem = {
            reason,
            retry: () => {
                this.$q.when(retryFn()).then(value => {
                    deferredRetry.resolve(value);
                }, value => {
                        deferredRetry.reject(value);
                    });
            },
            cancel: () => {
                deferredRetry.reject();
            }
        };
        this.push(retryItem);
        return deferredRetry.promise as ng.IHttpPromise<any>;
    }
        
    public push(retryItem) {
        this.retryQueue.push(retryItem);
        if (this.onItemAdded) {
            this.onItemAdded();
        }
    }

}
